export default __webpack_public_path__ + "static/custom-marker-shapes-d2bf88f2582620be117b6aaff1793965.png";